/**
 * Analytics event name constants.
 * Used by analyticsService and components to ensure consistent event names.
 * Must match the event catalog in app_notes/ANALYTICS_SERVICE_IMPLEMENTATION_PLAN.md.
 */

// Navigation and views
export const EVENT_VIEW_CHANGED = 'view_changed';

// Bet feed and bet cards
export const EVENT_BET_CARD_CLICKED = 'bet_card_clicked';
export const EVENT_IN_DEPTH_VIEWED = 'in_depth_viewed';
export const EVENT_FEED_SPORT_FILTER = 'feed_sport_filter';
export const EVENT_FEED_PAGE_LOADED = 'feed_page_loaded';

// Search
export const EVENT_SEARCH_PERFORMED = 'search_performed';

// Sniped odds
export const EVENT_SNIPED_TAB_CHANGED = 'sniped_tab_changed';
export const EVENT_SNIPED_FILTERS_CHANGED = 'sniped_filters_changed';
export const EVENT_SNIPED_VIEW_MORE = 'sniped_view_more';
export const EVENT_SNIPED_PAGE_LOADED = 'sniped_page_loaded';

// Parlay generator
export const EVENT_PARLAY_SETTINGS_OPENED = 'parlay_settings_opened';
export const EVENT_PARLAY_GENERATED = 'parlay_generated';
export const EVENT_BETSLIP_GENERATED = 'betslip_generated';

// Bet cart
export const EVENT_BET_CART_OPENED = 'bet_cart_opened';
export const EVENT_BET_CART_UPDATED = 'bet_cart_updated';

// Registration and auth
export const EVENT_REGISTRATION_MODAL_SHOWN = 'registration_modal_shown';
export const EVENT_REGISTRATION_CTA_CLICKED = 'registration_cta_clicked';
export const EVENT_LOGIN_SUCCESS = 'login_success';
export const EVENT_LOGIN_FAILED = 'login_failed';
export const EVENT_REGISTER_SUCCESS = 'register_success';
export const EVENT_LOGOUT = 'logout';
export const EVENT_PASSWORD_RESET_REQUESTED = 'password_reset_requested';

// Ads
export const EVENT_AD_CLICKED = 'ad_clicked';
export const EVENT_AD_CTA_CLICKED = 'ad_cta_clicked';

// Settings and profile
export const EVENT_SETTINGS_SAVED = 'settings_saved';
export const EVENT_PROFILE_UPDATED = 'profile_updated';
export const EVENT_TIER_MODAL_VIEWED = 'tier_modal_viewed';

// Ordered list of event names for activity report filter dropdown
export const ACTIVITY_EVENT_NAMES = [
    'view_changed', 'bet_card_clicked', 'in_depth_viewed', 'feed_sport_filter', 'feed_page_loaded',
    'search_performed', 'sniped_tab_changed', 'sniped_filters_changed', 'sniped_view_more', 'sniped_page_loaded',
    'parlay_settings_opened', 'parlay_generated', 'betslip_generated', 'bet_cart_opened', 'bet_cart_updated',
    'registration_modal_shown', 'registration_cta_clicked', 'login_success', 'login_failed', 'register_success',
    'logout', 'password_reset_requested', 'ad_clicked', 'ad_cta_clicked', 'settings_saved', 'profile_updated', 'tier_modal_viewed'
];
